import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { TimelinePresetOption } from '../Filter/types'

export const useTimelineLabels = () => {
    const { t } = useTranslation('translations')

    const options = useMemo(() => {
        const options: Record<TimelinePresetOption, string> = {
            last12Months: t('filters.timeline.options.last12Months'),
            previousMonth: t('filters.timeline.options.previousMonth'),
            previous2Months: t('filters.timeline.options.previous2Months'),
            previousQuarter: t('filters.timeline.options.previousQuarter'),
        }

        return options
    }, [t])

    return options
}
